import * as WindowManagement from "@omni/services/windowManagement";
import { WindowKeys } from "@omni/services/windowManagement";
import * as LocalStorage from "@omni/utils/localStorage.utils";

import { StorageKeys } from "@/utils/enums";

export default class MockDateService {
    static getMockDate() {
        const localStorageValue = LocalStorage.getItem(StorageKeys.MockDate);
        return localStorageValue ? new Date(localStorageValue) : null;
    }

    static setMockDate(date: Date) {
        LocalStorage.setItem(StorageKeys.MockDate, date.toISOString());
        console.log("Mock date set to:", date);
    }
}

const init = () => {
    WindowManagement.saveObject(WindowKeys.MOCK_DATE, MockDateService);
};

export { init };
